import { useEffect, useState } from 'react';

interface Props {
    id: string;
}

function useScrollEnd({ id }:Props) {
  const [isScrolling, setIsScrolling] = useState(false);
  const onScroll = () => setIsScrolling(true);
  useEffect(() => {
    const element = document.querySelector<HTMLDivElement>(`#${id}`);
    const onScrollEnd = () => {
      setIsScrolling(false);
    };
    element?.addEventListener('scrollend', onScrollEnd);
    return () => element?.removeEventListener('scrollend', onScrollEnd);
  }, [id]);
  return {
    isScrolling, onScroll,
  };
}

export default useScrollEnd;
